import { CoralRequest, CoralInterceptor } from '@amzn/ihm-js-coral-client';

const addHeaders = (request: CoralRequest): CoralRequest =>
  request.clone({ headers: [...request.headers, ['Accept', 'application/json']] });

/**
 * Header interceptor that adds 'Accept: application/json' header to all outgoing requests.
 * This ensures that 5xx errors from backends are returned as JSON instead of HTML error pages,
 * enabling better error handling and separation of client-side vs server-side errors.
 */
const createHeaderInterceptor = (): CoralInterceptor => ({
  intercept(request, next) {
    return next.handle(addHeaders(request));
  },
});

export const HeaderInterceptor = createHeaderInterceptor();
